const ServerAddress = import.meta.env.VITE_SERVER_ADDRESS;

export const ServerStorage: string = `${ServerAddress}/storage/`;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
